import type { Planet, SpyScanResponse } from '@kaeliux/shared';
import { toDate } from '@kaeliux/shared';
import { authedPost } from './http';
import { normalizePlanet } from './planetNormalization';

/**
 * Counter-espionage scan — real backend flavour. Mock mode swaps this file
 * for `services/mock/spyScan.service.ts` via the Vite alias.
 */

export interface ScanForSpiesResult extends SpyScanResponse {
    planet: Planet;
}

export async function scanForSpies(planetId: string): Promise<ScanForSpiesResult> {
    const data = await authedPost<SpyScanResponse & { planet: unknown }>('/scanForSpies', { planetId });
    return {
        ...data,
        nextScanAvailableAt: toDate(data.nextScanAvailableAt),
        planet: normalizePlanet(data.planet, planetId),
    };
}
